import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import BaseballMatchLineupStore from './store';
import EmptyLIneupImage from 'images/sports/common/empty-data.png';
import {
  Lineup,
  Container,
  Header,
  EmptyLineup,
  Tab,
  Table,
  Button
} from './styled';
import BaseballMatchLineupPitcherTable from './pitcherTable';
import BaseballMatchLineupBatterTable from './batterTable';
import clsx from 'clsx';
import Seo from '../../../../../components/seo';

const BaseballMatchLineup = () => {
  let { id } = useParams();
  const { getLineup, data } = BaseballMatchLineupStore();
  const [selectedTeam, setSelectedTeam] = useState('home');

  useEffect(() => {
    getLineup(id);
  }, []);

  const onClickTab = (team) => {
    setSelectedTeam(team);
  };

  const teamData = useMemo(() => {
    if (selectedTeam === 'home') {
      return {
        pitchers: data.homePitchers,
        batters: data.homeBatters
      };
    } else {
      return {
        pitchers: data.awayPitchers,
        batters: data.awayBatters
      };
    }
  }, [
    selectedTeam,
    data.homePitchers,
    data.homeBatters,
    data.awayBatters,
    data.awayPitchers
  ]);

  if (data.loading) {
    return null;
  } else {
    return (
      <Lineup>
        <Seo title={'스포츠 야구 상세 라인업'} />
        <Tab>
          <Button
            className={clsx(selectedTeam === 'home' ? 'active' : '')}
            onClick={() => onClickTab('home')}
          >
            {data.homeName}
          </Button>
          <Button
            className={clsx(selectedTeam === 'away' ? 'active' : '')}
            onClick={() => onClickTab('away')}
          >
            {data.awayName}
          </Button>
        </Tab>
        {/* 투수 라인업 */}
        <Container>
          <Header>
            <h2>투수</h2>
          </Header>

          {/* 투수 기록 */}
          {data.isEmpty.pitcher ? (
            <EmptyLineup>
              <img src={EmptyLIneupImage} alt="empty" />
              <h3>라인업이 발표되면 업데이트 됩니다 :)</h3>
            </EmptyLineup>
          ) : (
            <Table>
              <BaseballMatchLineupPitcherTable data={teamData.pitchers} />
            </Table>
          )}
        </Container>
        {/* 투수 라인업 */}

        {/* 타자 라인업 */}
        <Container>
          <Header>
            <h2>타자</h2>
          </Header>

          {/* 타자 기록 */}
          {data.isEmpty.pitcher ? (
            <EmptyLineup>
              <img src={EmptyLIneupImage} alt="empty" />
              <h3>라인업이 발표되면 업데이트 됩니다 :)</h3>
            </EmptyLineup>
          ) : (
            <Table>
              <BaseballMatchLineupBatterTable data={teamData.batters} />
            </Table>
          )}
        </Container>
        {/* 타자 라인업 */}
      </Lineup>
    );
  }
};

export default BaseballMatchLineup;
